import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

const Preloader = () => {
  const [progress, setProgress] = useState(0);
  const [isLarge, setIsLarge] = useState(false); // State to toggle size
  const [isVisible, setIsVisible] = useState(true); // State to control overlay visibility

  useEffect(() => {
    // Function to start the progress bar and size transition
    const startProcess = () => {
      const sizeTimeout = setTimeout(() => {
        setIsLarge(true); // Change the size of the progress-box
      }, 1000); // Adjust the delay as needed

      return () => clearTimeout(sizeTimeout);
    };

    startProcess();

    // Fallback to start the process after 5 seconds if the window hasn't loaded
    // const fallbackTimeout = setTimeout(() => {
    //   startProcess();
    // }, 3000);
    

    // Listen for the window load event
    // window.addEventListener('load', () => {
    //   clearTimeout(fallbackTimeout); // Clear the fallback timeout if the window loads
    //   startProcess(); // Start the process
    // });

    
    // return () => clearTimeout(fallbackTimeout);
  }, []);

  useEffect(() => {
    if (isLarge) {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            
            // Hide the overlay after 2 seconds
            setTimeout(() => {
              setIsVisible(false);
            }, 1000);
            
            return 100;
          }
          return prevProgress + 3;
        });
      }, 50);
      
      return () => clearInterval(interval);
    }
  }, [isLarge]);

  //if (!isVisible) return null; // If not visible, return null to hide the overlay

  return (
    <div className="view-overlay">
      <div className="preloader-container">
        <Helmet>
          <style>{`
            .preloader-container {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100vh;
              width: 100vw;
              background-color:rgb(227 227 227 / 25%);
              backdrop-filter: blur(10px);
              -webkit-backdrop-filter: blur(10px);
              color: #9194a5;
              font-family: 'Courier New', Courier, monospace;
            }
            
            .progress-box {
              position: relative;
              padding: 20px;
              text-align: center;
              width: ${isLarge ? '30vh' : '10vh'}; /* Toggle width based on state */
              transition: width 0.5s ease-in-out; /* Smooth transition for width */
              background-color: rgb(255 255 255 / 31%);
              flex-direction: row;
              align-items: center;
              justify-content: center;
            }

            /* Corner borders */
            .progress-box::before,
            .progress-box::after {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              pointer-events: none;
            }

            .progress-box::before,
            .progress-box::after {
              border-style: solid;
              border-color: #b9bccb;
            }

            .progress-box::before {
              top: 0;
              left: 0;
              border-width: 3px 0 0 3px; /* Top-left corner */
              height: 20px;
              width: 20px;
            }

            .progress-box::after {
              bottom: 0;
              right: 0;
              border-width: 0 3px 3px 0; /* Bottom-right corner */
              height: 20px;
              width: 20px;
            }

            .progress-box .corner-top-right,
            .progress-box .corner-bottom-left {
              position: absolute;
              border-style: solid;
              border-color: #b9bccb;
            }

            .progress-box .corner-top-right {
              top: 0;
              right: 0;
              border-width: 3px 3px 0 0; /* Top-right corner */
              height: 20px;
              width: 20px;
            }

            .progress-box .corner-bottom-left {
              bottom: 0;
              left: 0;
              border-width: 0 0 3px 3px; /* Bottom-left corner */
              height: 20px;
              width: 20px;
            }
            
            .progress-text {
              margin-bottom: 8px;
              font-size: 12px;
            }
            
            .progress-bar {
              width: 100%;
              height: 15px;
              background-color: #fff;
              backdrop-filter: blur(5px);
              position: relative;
            }
            
            .progress {
              height: 100%;
              background-color: #b9bccb;
            }
            
            .progress-percentage {
              margin-top: 8px;
              font-size: 14px;
            }
            
            .loading-text {
              margin-top: 20px;
              font-size: 11px;
              color: #fff;;
            }
            
            .unable-text {
              margin-top: 10px;
              font-size: 11px;
              color: #fff;
            }
          `}</style>
        </Helmet>
        
        <div className="progress-box">
          <div className="corner-top-right"></div>
          <div className="corner-bottom-left"></div>
          {isLarge && (
            <>
              <div className="progress-text">{'<'}SYSTEM LOADING{' />'}</div>
              <div className="progress-bar">
                <div className="progress" style={{ width: `${progress}%` }}></div>
              </div>
              <div className="progress-percentage">{progress}%</div>
            </>
          )}
        </div>
        <div className="loading-text p-2">{!isVisible? "This site is still under construction. ": ''}</div>
        <div className="unable-text p2">{!isVisible? "ByWaldo online will be ready for you soon bestie:) ": ''}</div>
      </div>
    </div>
  );
};

export default Preloader;
